<div class="alert alert-solid-brand alert-bold" role="alert">
	<div class="alert-icon"><i class="flaticon-exclamation-1"></i></div>
	<div class="alert-text">{{description}}</div>
</div>
